module.exports = __webpack_public_path__ + "img/case17.d653d9dc.jpg";